import { Box, Container, Typography } from '@mui/material';

import React from 'react';

const StepIndicator = ({ activeStep }) => {
  const steps = ['Personal Details', 'Upload CV', 'Experience', 'Portfolio'];
  
  return (
    <Box sx={{ 
      py: 2,

    }}>
      <Container maxWidth="md">
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'relative'
        }}>
       
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: 0,
            right: 0,
            height: '1px',
            backgroundColor: '#e0e0e0',
            zIndex: 1
          }}>
            <Box sx={{
              height: '100%',
              backgroundColor: '#FF5722',
              width: `${(activeStep / (steps.length - 1)) * 100}%`,
              transition: 'width 0.3s ease'
            }} />
          </Box>
          
          {steps.map((label, index) => (
            <Box key={label} sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              zIndex: 2,
              backgroundColor: '#f5f5f5',
              px: 0.5,
              minWidth: 0,
              flex: '0 1 auto'
            }}>
              <Box sx={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                backgroundColor: index === activeStep ? '#e0e0e0' : (index < activeStep ? '#FF5722' : '#e0e0e0'),
                color: index < activeStep ? 'white' : '#666',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: '10px',
                transition: 'all 0.3s ease'
              }}>
                {index + 1}
              </Box>
              <Typography sx={{
                fontSize: '10px',
                fontWeight: index === activeStep ? 'bold' : 'normal',
                color: index === activeStep ? 'black' : '#666',
                textAlign: 'center',
                whiteSpace: 'nowrap', 
              }}>
                {label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default StepIndicator;